import { NavLink } from 'react-router-dom'
import React from 'react'
import {
  DollarOutlined,
  DownOutlined,
  SnippetsOutlined,
  VerticalAlignBottomOutlined,
  VerticalAlignTopOutlined,
} from '@ant-design/icons'
import { routersPath } from '@router/routes-path'
import DropdownUI from '@components/ui/DropDownUI/DropdownUi'
import { Menu } from 'antd'

export interface ITabs {
  title: JSX.Element | Element
  pages: routersPath[]
}

export const accountantTabs: ITabs[] = [
  {
    title: (
      <DropdownUI
        menu={
          <Menu
            items={[
              {
                key: routersPath.REPORTS,
                label: (
                  <NavLink to={routersPath.REPORTS}>
                    <span>Отчеты</span>
                  </NavLink>
                ),
                icon: <SnippetsOutlined />,
              },
              {
                key: routersPath.INCOMES,
                label: (
                  <NavLink to={routersPath.INCOMES}>
                    <span>Приходы</span>
                  </NavLink>
                ),
                icon: <VerticalAlignBottomOutlined />,
              },
              {
                key: routersPath.EXPENSES,
                label: (
                  <NavLink to={routersPath.EXPENSES}>
                    <span>Расходы</span>
                  </NavLink>
                ),
                icon: <VerticalAlignTopOutlined />,
              },
              {
                key: routersPath.SALARY,
                label: (
                  <NavLink to={routersPath.SALARY}>
                    <span>Зарплаты</span>
                  </NavLink>
                ),
                icon: <DollarOutlined />,
              },
            ]}
          />
        }
      >
        <span>
          <SnippetsOutlined />
          Отчеты
          <DownOutlined style={{ marginLeft: '5px' }} />
        </span>
      </DropdownUI>
    ),
    pages: [
      routersPath.REPORTS,
      routersPath.REPORT,
      routersPath.INCOMES,
      routersPath.EXPENSES,
      routersPath.SALARY,
    ],
  },
]
